import React from 'react'
import { Card, CARD_THEME } from '@st-operations/uikit/src/v2/index.js'
import format from '@st-operations/uikit/lib/format.js'
import { count } from 'underscore.string'

import { UIKIT_COLORS } from '../constants.js'
import RectLoader from '_components/rect-loader/index.jsx'

import './styles.scss'

const UniqueCountsCards = ({ data, loading }) => {
  const COUNTS = [
    // {
    //   name: 'Unique Domains',
    //   color: UIKIT_COLORS.dark_green_2,
    //   count: data.uniqueDomains?.value || 0,
    //   coverage: (data.uniqueDomains?.coverage * 100).toFixed(2),
    // },
    {
      name: 'Unique Estids',
      color: UIKIT_COLORS.yellow_light,
      count: data.uniqueEstids?.value || 0,
      coverage: (data.uniqueEstids?.coverage * 100).toFixed(2),
    },
    {
      name: 'Unique IP Addresses',
      color: UIKIT_COLORS.pink_light,
      count: data.uniqueIps?.value || 0,
      coverage: (data.uniqueIps?.coverage * 100).toFixed(2),
    },
    {
      name: 'Unique Maids',
      color: UIKIT_COLORS.blue_light,
      count: data.uniqueMAIDs?.value || 0,
      coverage: (data.uniqueMAIDs?.coverage * 100).toFixed(2),
    },
    {
      name: 'Unique Hems Md5',
      color: UIKIT_COLORS.purple_light,
      count: data.uniqueHemsMd5?.value || 0,
      coverage: (data.uniqueHemsMd5?.coverage * 100).toFixed(2),
    },
    {
      name: 'Unique Hems Sha1',
      color: UIKIT_COLORS.purple_light,
      count: data.uniqueHemsSha1?.value || 0,
      coverage: (data.uniqueHemsSha1?.coverage * 100).toFixed(2),
    },
    {
      name: 'Unique Hems Sha256',
      color: UIKIT_COLORS.purple_light,
      count: data.uniqueHemsSha256?.value || 0,
      coverage: (data.uniqueHemsSha256?.coverage * 100).toFixed(2),
    },
    {
      name: 'Unique TTD IDs',
      color: UIKIT_COLORS.dark_green_2,
      count: data.uniqueTtdIds?.value || 0,
      coverage: (data.uniqueTtdIds?.coverage * 100).toFixed(2),
    },
  ]

  return (
    <Card component="section" theme={CARD_THEME.NO_SHADOW} className="unique-counts-cards">
      <div className="unique-counts-cards__title-section">
        <h1 className="unique-counts-cards__title-section-main">Unique Counts</h1>
        <span className="unique-counts-cards__title-section-sub">• Monthly projections</span>
      </div>
      <div className="unique-counts-cards__head">
        <p>Type</p>
        <p>Unique Counts</p>
        <p>Coverage</p>
      </div>
      <div className="unique-counts-cards__counts">
        <For each="count" of={COUNTS}>
          <div key={count.name} className="unique-counts-cards__count">
            <div
              className="unique-counts-cards__count-tag"
              style={{
                backgroundColor: count.color,
                height: '100%',
              }}
            >
              &nbsp;
            </div>
            <p>{count.name}</p>
            <If condition={loading}>
              <RectLoader width={60} height={16} />
              <RectLoader width={60} height={16} />
            </If>
            <If condition={!loading}>
              <>
                <p>{format('metric', count.count)}</p>
                <p>{isNaN(count.coverage) ? 0 : count.coverage}%</p>
              </>
            </If>
          </div>
        </For>
      </div>
    </Card>
  )
}

export default UniqueCountsCards
